import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";

import SettingsBackupRestoreIcon from "@material-ui/icons/SettingsBackupRestore";
import SaveIcon from "@material-ui/icons/Save";
import EditIcon from "@material-ui/icons/Edit";
import DashboardIcon from "@material-ui/icons/Dashboard";

export default function EditIcons(props) {
  const elements = [];
  const classes = props.classes;
  if (props.editable) {
    elements.push(<div key={"sep1"} className={classes.separator} />);
    elements.push(
      <IconButton
        key={"edit1"}
        edge="start"
        className={classes.menuButton}
        color="inherit"
        aria-label="Edit stacks"
        onClick={props.onStackEdit}
      >
        <DashboardIcon />
      </IconButton>
    );

    if (props.edit) {
      elements.push(
        <React.Fragment key="editblock1">
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="Save"
            onClick={props.onSave}
          >
            <SaveIcon />
          </IconButton>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="Reset"
            onClick={props.onReset}
          >
            <SettingsBackupRestoreIcon />
          </IconButton>
        </React.Fragment>
      );
    } else {
      elements.push(
        <IconButton
          key="edit2"
          edge="start"
          className={classes.menuButton}
          color="inherit"
          aria-label="Reset"
          onClick={props.onEdit}
        >
          <EditIcon />
        </IconButton>
      );
    }
    elements.push(<div key="sep2" className={classes.separator} />);
  }
  return <React.Fragment>{elements}</React.Fragment>;
}
